// components/admin/spaces/SpaceForm.jsx
import {
    DynamicInputSelect,
    InputCheckBox,
    InputEmail,
    InputText,
    InputTextArea,
} from '../../../utils/dynamicForm';
import { DynamicInputMultiSelect } from '../../../utils/dynamicExtraForm';
import { InputImagesBlock } from '../../../utils/imageTools';
import { LocationPicker } from '../../../utils/LocationPicker';
import { Spinner, Message } from '../../index';

const FormRow = ({ children }) => <div className="form-row-2cols">{children}</div>;

export default function SpaceForm({
                                      edit,
                                      formCleanHandler,
                                      isLoading,
                                      isError,
                                      register,
                                      errors,
                                      watch,
                                      isLoadingUpdate,
                                      isLoadingPost,
                                      handleSubmit,
                                      submitHandler,
                                      error,
                                      setValue,
                                      t,
                                      images_path,
                                      setFileInputs,
                                      fileInputs,
                                      control,
                                      formRef
                                  }) {

    const buildingTypeOptions = [
        {value: 'shop', label: 'Μαγαζί'},
        {value: 'plot', label: 'Οικόπεδο'},
        {value: 'residence', label: 'Οικία'},
        {value: 'public', label: 'Δημόσιο'},
        {value: 'other', label: 'Άλλο'},
    ];
    const squareMetersOptions = [
        {value: '100', label: '100'},
        {value: '101_200', label: '101-200'},
        {value: '201_300', label: '201-300'},
        {value: '301_500', label: '301-500'},
        {value: '501_1000', label: '501-1000'},
        {value: '1000+', label: '1000+'}
    ];

    const initialLat = watch('lat');
    const initialLng = watch('lng');

    return (
        <div className='admin-space-editor admin-panel-editor' data-mode={edit ? 'edit' : 'create'}>
            <div className='d-flex justify-content-end gap-2 mb-3'>
                <button
                    type='button'
                    className='btn btn-secondary'
                    onClick={formCleanHandler}
                >
                    {t('Close')}
                </button>
                <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => formRef.current?.requestSubmit()}
                    disabled={isLoadingPost || isLoadingUpdate}
                >
                    {isLoadingPost || isLoadingUpdate ? (
                        <span className='spinner-border spinner-border-sm'/>
                    ) : t('Save')}
                </button>
            </div>

            {isLoading ? (
                <Spinner/>
            ) : isError ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <form ref={formRef} onSubmit={handleSubmit(submitHandler)}>
                    <div className='basic-data form-group-block'>
                        <div className='basic-data-title form-group-title'>{t("ΓΕΝΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ")}</div>
                        {InputText({
                            register,
                            errors,
                            label: 'Όνομα / Τίτλος / ID',
                            name: 'name',
                            placeholder: '',
                            isRequired: true
                        })}
                        <div className="form-row-2cols">
                            {InputTextArea({
                                register,
                                errors,
                                label: 'Περιγραφή του Χώρου',
                                name: 'description',
                                placeholder: "",
                                isRequired: false
                            })}
                            {InputTextArea({
                                register,
                                errors,
                                label: 'Extra Notes',
                                name: 'extraNotes',
                                placeholder: '',
                                isRequired: false
                            })}
                        </div>
                        {InputImagesBlock({
                            setValue,
                            errors,
                            watch,
                            register,
                            label: 'Images',
                            name: 'images',
                            placeholder: 'Max Size 10MB',
                            isRequired: false,
                            images_path,
                            fileInputs,
                            setFileInputs,
                            maxImages: 5,
                            t
                        })}
                        <FormRow>
                            {DynamicInputSelect({
                                register,
                                errors,
                                label: 'Square Meters',
                                name: 'squareMeters',
                                placeholder: "select",
                                isRequired: false,
                                data: squareMetersOptions,
                                value: 'label',
                                id: 'value',
                                icons: false
                            })}
                            {InputText({
                                register,
                                errors,
                                label: 'Όροφοι',
                                name: 'floors',
                                placeholder: '',
                                isRequired: false
                            })}
                        </FormRow>

                        <FormRow>
                            <DynamicInputMultiSelect
                                control={control} errors={errors} label='Building Type' name='building_type'
                                placeholder='select' isRequired={false} data={buildingTypeOptions} value='label'
                                icons={false} id='building_type' t={t}
                            />
                        </FormRow>
                    </div>
                    <div className='address-data form-group-block'>
                        <div className='address-data-title form-group-title'>{t("ΣΤΟΙΧΕΙΑ ΔΙΕΥΘΥΝΣΗΣ")}</div>
                        <FormRow>
                            {InputText({
                                register,
                                errors,
                                label: 'Διεύθυνση',
                                name: 'address',
                                placeholder: '',
                                isRequired: false
                            })}
                            {InputText({
                                register,
                                errors,
                                label: 'ΤΚ',
                                name: 'postal',
                                placeholder: '',
                                isRequired: false
                            })}
                        </FormRow>
                    </div>

                    <div className='location-data form-group-block'>
                        <div className='location-data-title form-group-title'>{t("GPS DATA")}</div>
                        {LocationPicker({
                            register, errors, watch, setValue, isRequired: false, placeholder: "",
                            initialLat, initialLng
                        })}
                    </div>

                    <div className='contact-data form-group-block'>
                        <FormRow>
                            <div className='contact-data-title form-group-title'>{t("ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ")}</div>
                            {InputText({
                                register,
                                errors,
                                label: 'Τηλέφωνο Επικοινωνίας',
                                name: 'phone',
                                placeholder: '',
                                isRequired: false
                            })}
                            {InputEmail({
                                register,
                                errors,
                                label: 'Email',
                                name: 'email',
                                placeholder: '',
                                isRequired: false
                            })}
                        </FormRow>
                    </div>

                    {InputCheckBox({
                        register,
                        errors,
                        watch,
                        name: 'confirmed',
                        label: 'Confirmed',
                        isRequired: false,
                        placeholder: 'Confirmed'
                    })}
                    {InputCheckBox({
                        register,
                        errors,
                        watch,
                        name: 'blocked',
                        label: 'Blocked',
                        isRequired: false,
                        placeholder: 'Blocked'
                    })}
                    {InputCheckBox({
                        register,
                        errors,
                        watch,
                        name: 'under_review',
                        label: 'Under Review',
                        isRequired: false,
                        placeholder: 'Under Review'
                    })}

                    <div className='d-flex justify-content-end gap-2 mt-3'>
                        <button type='button' className='btn btn-secondary'
                                onClick={formCleanHandler}>{t('Close')}</button>
                        <button type='submit' className='btn btn-primary' disabled={isLoadingPost || isLoadingUpdate}>
                            {isLoadingPost || isLoadingUpdate ?
                                <span className='spinner-border spinner-border-sm'/> : t('Save')}
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
}
